export default "__VITE_ASSET__DNy4BzGL__"